import { Controller } from "@hotwired/stimulus"

// The broker logo buttons on the import wizard's first step.
//
// The buttons and the File type select are ONE control: clicking a broker
// button writes that broker's format key into the select, and changing the
// select highlights the matching button. The select stays the thing the form
// actually posts — the buttons are a shortcut over it, so a member with
// JavaScript disabled (or a CSP hiccup) still has the full picker.
//
// The "Columns we recognise" panel is part of the same control: it states the
// header names for the format that is CURRENTLY selected, so it has to move
// with the selection. Every format's table is in the page and this shows one.
export default class extends Controller {
  static targets = ["button", "select", "columns"]

  connect() {
    this.sync()
  }

  choose(event) {
    this.selectTarget.value = event.currentTarget.dataset.formatKey
    this.sync()
  }

  // The select is the form field this whole control exists to post, so it is
  // required rather than guarded: if it ever went missing, throwing here says
  // so, where a `hasSelectTarget` guard would leave a picker that silently
  // does nothing.
  sync() {
    const current = this.selectTarget.value
    this.buttonTargets.forEach((button) => {
      const chosen = button.dataset.formatKey === current
      button.classList.toggle("active", chosen)
      button.setAttribute("aria-pressed", String(chosen))
    })
    this.columnsTargets.forEach((panel) => {
      panel.classList.toggle("d-none", panel.dataset.formatKey !== current)
    })
  }
}
